<div class="cancellation-container">
  <div class="cancellation-content">
    <h1>Cancellation Policy</h1>
    <p>This cancellation policy outlines the terms and conditions for cancelling bookings with MyFleetMan Car Rental Software.</p>
    
    <h2>1. Cancellation Timeframes</h2>
    <p>You may cancel your booking at any time, but cancellation fees may apply based on the timing of your cancellation:</p>
    <ul>
      <li><strong>Free Cancellation:</strong> More than 24 hours before the scheduled pickup time</li>
      <li><strong>50% Refund:</strong> Between 12-24 hours before the scheduled pickup time</li>
      <li><strong>No Refund:</strong> Less than 12 hours before the scheduled pickup time</li>
    </ul>
    
    <h2>2. How to Cancel</h2>
    <p>To cancel your booking, you can:</p>
    <ul>
      <li>Use the cancellation option in your booking confirmation email</li>
      <li>Contact our customer support team</li>
      <li>Cancel through your account dashboard</li>
    </ul>
    
    <h2>3. Refund Processing</h2>
    <p>Refunds will be processed within 5-7 business days to the original payment method used for the booking. Processing times may vary depending on your bank or payment provider.</p>
    
    <h2>4. Force Majeure</h2>
    <p>In the event of circumstances beyond our control (such as natural disasters, government restrictions, or vehicle unavailability), we reserve the right to cancel bookings and provide full refunds or alternative arrangements.</p>
    
    <h2>5. No-Show Policy</h2>
    <p>If you fail to show up for your scheduled pickup without prior cancellation, no refund will be provided and the full booking amount will be charged.</p>
    
    <h2>6. Vehicle Availability</h2>
    <p>We reserve the right to cancel bookings if the requested vehicle becomes unavailable. In such cases, we will offer alternative vehicles or provide a full refund.</p>
    
    <h2>7. Contact Information</h2>
    <p>For cancellation-related inquiries, please contact our customer support team at support&#64;myfleetman.com or call our helpline.</p>
    
    <h2>8. Policy Updates</h2>
    <p>This cancellation policy may be updated from time to time. Any changes will be communicated to users through our website or email notifications.</p>
  </div>
</div>